import { vec4, vec3 } from "gl-matrix";
import { IBoundingBoxObject, BoundingBox } from "../../Common/Util/BoundingBox";
import { Ray } from "../../Common/Math/Ray";
import { PropertyAnimation } from "../../Common/Animation/PropertyAnimation";

export class Light implements IBoundingBoxObject {

    public animatedProperties: PropertyAnimation;

    public type: LightType;
    public position: vec4;
    public color: vec4;

    constructor(type: LightType, position: vec3, color: vec3, decay: number) {
        this.type = type;
        // Use the W component to determine which type of light is used
        this.position = vec4.fromValues(position[0], position[1], position[2], type == LightType.Point ? 1.0 : 0);
        this.color = vec4.fromValues(color[0], color[1], color[2], decay);
    }

    getPosition(): vec4 {
        return this.position;
    }

    getBoundingBox(): BoundingBox {
        let d = 2;

        let min = vec3.subtract(vec3.create(), [this.position[0], this.position[1], this.position[2]], [d, d, d]);
        let max = vec3.add(vec3.create(), [this.position[0], this.position[1], this.position[2]], [d, d, d]);

        return new BoundingBox(min, max);
    }
    canIntersectRay(): boolean {
        return false;
    }
    intersectsRay(ray: Ray): boolean {
        return false;
    }
}

export enum LightType {
    Point = 0,
    Directional = 1
}
